import { useEffect, useState, useRef } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";
import differenceInYears from "date-fns/differenceInYears";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineClose } from "react-icons/ai";
import { activateAccount } from "../../actions/student.action";
import ErrorInputComponent from "../../components/ErrorInputComponent";
import DocButtomButton from "../../components/DocButtomButton";
import DropDownInput from "../../components/DropDownInput";
import "./onboarding.css";
import { Loading } from "../../utils/helpers/constants";
import FeePaymentModal from "../../components/modals/FeePaymentModal";
import { industries } from "../../utils/mapper/enums/AppEnums";

export default function CompleteUserProfile() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [matricNumber, setMatricNumber] = useState("");
  const [modal, setModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [otherLinks, setOtherLinks] = useState(false);
  const cancelButtonRef = useRef(null);

  const {
    user: { activateUserLoading, userData, paymentModal, paymentMessage },
  } = useSelector(({ studentReducer }) => ({
    user: studentReducer,
  }));

  const { phoneNumber, emailAddress } = userData;

  function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  if (isObjectEmpty(userData)) {
    history.push("/login");
  }

  useEffect(() => {
    setMatricNumber(userData.matricNumber);
  }, []);

  const validationSchema = Yup.object({
    dateOfBirth: Yup.date()
      .nullable()
      .test("dateOfBirth", "Should be greater than 16", function (value) {
        return differenceInYears(new Date(), new Date(value)) >= 16;
      }),
    emailAddress: Yup.string().email().required("Email address is required"),
    phoneNumber: Yup.string()
      .required("Phone number is Required")
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
        "Phone number is not valid"
      ),
    industry: Yup.string().when("employmentStatus", {
      is: "EMPLOYED",
      then: Yup.string().required("Industry is required"),
    }),
    industry: Yup.string().when("employmentStatus", {
      is: "SELF_EMPLOYED",
      then: Yup.string().required("Industry is required"),
    }),
  });

  const { handleSubmit, handleChange, values, errors } = useFormik({
    initialValues: {
      businessName: "",
      companyName: "",
      dateOfBirth: "",
      emailAddress: emailAddress,
      industry: "",
      phoneNumber: phoneNumber,
      employmentStatus: "SELF_EMPLOYED",
      linkedIn: "",
      twitter: "",
      facebook: "",
      skillToLearn: "",
    },
    validationSchema,
    onSubmit(values) {
      const payload = {
        businessName:
          values.employmentStatus === "SELF_EMPLOYED"
            ? values.businessName
            : null,
        companyName:
          values.employmentStatus === "EMPLOYED" ? values.companyName : null,
        dateOfBirth: values.dateOfBirth,
        emailAddress: values.emailAddress,
        industry:
          values.employmentStatus === "UNEMPLOYED" ? null : values.industry,
        phoneNumber: values.phoneNumber,
        employmentStatus: values.employmentStatus,
        links: {
          linkedIn: values.linkedIn,
          twitter: values.twitter,
          facebook: values.facebook,
        },
        skillToLearn: values.skillToLearn,
      };
      const navigateLink = () => history.push("/onboarding/create-password");
      const alumniFeeLink = () => history.push("/alumni-fee/payment");
      console.log({ payload });
      //check for year and if due is paid
      const duePaid = false;
      if (duePaid) {
        setModal(true);
      } else {
        dispatch(
          activateAccount(payload, matricNumber, navigateLink, alumniFeeLink)
        );
      }
    },
  });

  const today = new Date();
  // const numberOfYearsToMinus = 17;
  // const acceptableDate = today.getFullYear - numberOfYearsToMinus;
  // const date = today.setDate(acceptableDate);
  const defaultValue = new Date(today).toISOString().split("T")[0]; // yyyy-mm-dd

  const employmentStatus = [
    { name: "Self Employed", value: "SELF_EMPLOYED" },
    { name: "Employed", value: "EMPLOYED" },
    { name: "Unemployed", value: "UNEMPLOYED" },
  ];

  const loadState = activateUserLoading === Loading.FETCHING;

  return (
    <div className="flex flex-column justify-center">
      <div className="App-height p-5 md:w-1/3">
        <div>
          <AiOutlineClose
            size={25}
            className="mt-5"
            onClick={() => history.goBack()}
          />
          <h1 className="a_acc_header mt-2">Complete your profile</h1>
          <p className="a_acc_header_text">
            Add additional information that would allow people know who you are
            what you do.
          </p>
        </div>
        <form className="mt-10" onSubmit={handleSubmit}>
          <input
            className="appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
            id="inline-full-name"
            type="tel"
            name="phoneNumber"
            onChange={handleChange}
            placeholder="Phone Number"
            defaultValue={phoneNumber}
          />
          <ErrorInputComponent error={errors.phoneNumber} />
          <input
            className="mt-3 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
            id="inline-full-name"
            type="email"
            name="emailAddress"
            onChange={handleChange}
            placeholder="Email Address"
            defaultValue={emailAddress}
          />
          <ErrorInputComponent error={errors.emailAddress} />
          <input
            className="mt-3 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
            id="inline-full-name"
            type="date"
            name="dateOfBirth"
            onChange={handleChange}
            placeholder="Birth Date"
            defaultValue={defaultValue}
          />
          <ErrorInputComponent error={errors.dateOfBirth} />
          <div className="mt-3">
            <DropDownInput
              list={employmentStatus}
              handleChange={handleChange}
              placeholder={"employment status"}
              name={"employmentStatus"}
              defaultValue={"UNEMPLOYED"}
            />
            {values.employmentStatus === "UNEMPLOYED" && (
              <input
                className="mb-3 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
                id="inline-full-name"
                type="text"
                name="skillToLearn"
                onChange={handleChange}
                placeholder="Skill you would like o learn"
              />
            )}
          </div>
          {values.employmentStatus === "SELF_EMPLOYED" ? (
            <div>
              <input
                className="mb-3 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
                id="inline-full-name"
                type="text"
                name="businessName"
                onChange={handleChange}
                placeholder="Business Name"
              />
              <ErrorInputComponent error={errors.businessName} />
            </div>
          ) : (
            values.employmentStatus === "EMPLOYED" && (
              <div>
                <input
                  className="mb-3 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
                  id="inline-full-name"
                  type="text"
                  name="companyName"
                  onChange={handleChange}
                  placeholder="Company Name"
                  autoComplete="off"
                />
                <ErrorInputComponent error={errors.companyName} />
              </div>
            )
          )}
          {values.employmentStatus !== "UNEMPLOYED" && (
            <div className="mb-3 inline-block relative w-full">
              <select
                name="industry"
                onChange={handleChange}
                className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 pt-4 pb-4 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
              >
                <option value="INFORMATION_TECHNOLOGY">
                  Select your industry
                </option>
                {industries.map((industry, index) => {
                  return (
                    <option key={index} value={industry.value}>
                      {industry.name}
                    </option>
                  );
                })}
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg
                  className="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </div>
              <ErrorInputComponent error={errors.industry} />
            </div>
          )}

          <input
            className="appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
            id="inline-full-name"
            type="linkedIn"
            name="linkedIn"
            onChange={handleChange}
            placeholder="LinkedIn"
          />
          <ErrorInputComponent error={errors.linkedIn} />
          <div
            onClick={() => setOtherLinks(!otherLinks)}
            className="bg-gray-200 py-3 text-center mt-2 cursor-pointer hover:bg-gray-100 rounded"
          >
            Add More Links
          </div>
          {otherLinks && (
            <>
              <input
                className="mt-3 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
                id="inline-full-name"
                type="text"
                name="twitter"
                onChange={handleChange}
                placeholder="Twitter"
              />
              <ErrorInputComponent error={errors.twitter} />

              <input
                className="mt-3 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
                id="inline-full-name"
                type="text"
                name="facebook"
                onChange={handleChange}
                placeholder="Facebook"
              />
              <ErrorInputComponent error={errors.facebook} />
            </>
          )}
        </form>
        <DocButtomButton
          loading={loadState}
          name={"Next"}
          func={() => handleSubmit()}
        />
      </div>
      <FeePaymentModal
        open={paymentModal}
        setOpen={setOpen}
        cancelButtonRef={cancelButtonRef}
        message={paymentMessage}
      />
    </div>
  );
}
